import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import { useTranslation } from "react-i18next";
import "leaflet/dist/leaflet.css";
import { SCOPE_MUNICIPALITIES } from "@/config/scope";

const CONCELLOS = SCOPE_MUNICIPALITIES.map((c) => ({
  name: c.name,
  coords: c.center,
  color: c.color,
}));

export default function MapSection() {
  const { t } = useTranslation();

  useEffect(() => {
    // Ensure invalidate size after mount, safety for hidden containers
  }, []);

  return (
    <section id="mapa" className="bg-salnes-ivory border-t hairline">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-10">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.28em] text-salnes-emerald mb-3">
              {t("map.eyebrow")}
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl text-salnes-ink leading-tight">
              {t("map.title")}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-salnes-stone text-sm leading-relaxed">
              {t("map.subtitle")}
            </p>
            <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2">
              {CONCELLOS.map((c) => (
                <div
                  key={c.name}
                  className="flex items-center gap-2 text-[13px] text-salnes-ink/80"
                  data-testid={`concello-item-${c.name.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-salnes-emerald" />
                  {c.name}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="relative rounded-2xl overflow-hidden border hairline shadow-[0_16px_48px_-24px_rgba(11,76,122,0.35)]"
          data-testid="salnes-map"
        >
          <MapContainer
            center={[42.5, -8.82]}
            zoom={11}
            scrollWheelZoom={false}
            style={{ height: 460, width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> · <a href="https://carto.com/attributions">CARTO</a>'
              url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
            />
            {CONCELLOS.map((c) => (
              <CircleMarker
                key={c.name}
                center={c.coords}
                radius={7}
                pathOptions={{
                  color: "#0B4C7A",
                  weight: 2,
                  fillColor: "#10B981",
                  fillOpacity: 0.85,
                }}
              >
                <Tooltip direction="top" offset={[0, -8]} opacity={1}>
                  <span className="font-medium">{c.name}</span>
                </Tooltip>
              </CircleMarker>
            ))}
          </MapContainer>
        </div>
      </div>
    </section>
  );
}
